export default class Utils {
  static getDevice() {
    if (window.innerWidth < 768) {
      return 'sp';
    } else {
      if (window.innerWidth > 1025) {
        return 'pc';
      }
      return 'tablet';
    }
  }

  static getHeight(el) {
    let target = (typeof el === 'string') ?
      document.querySelector(el) : el;
    return target.offsetHeight;
  }
}



// WEBPACK FOOTER //
// app/src/assets/js/class/Utils.js